export default __webpack_public_path__ + "static/media/20_footer_return.e36bf007.png";